"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuntimeComponent = RuntimeComponent;
exports.prepareRuntime = prepareRuntime;
exports.mountAutocomplete = mountAutocomplete;
const jsx_runtime_1 = require("react/jsx-runtime");
const SectionsWidget_1 = require("./SectionsWidget");
const react_dom_1 = require("react-dom");
const react_1 = require("react");
const cache_1 = require("./cache");
const EVENT_MOUNT = 'wpj:sections-autocomplete:mount';
let CacheInitialized = false;
function RuntimeComponent({ options }) {
    const { runtimeTarget, onInit } = options;
    const [portals, setPortals] = (0, react_1.useState)([]);
    const [cache, setCache] = (0, react_1.useState)({
        topLevelSections: [],
        _query: {},
        _fetchTopLevelSections: fetchTopLevelSections,
    });
    function fetchTopLevelSections() {
        if (CacheInitialized) {
            return;
        }
        const url = new URL('/admin/autocomplete/sections', `${window.location.protocol}//${window.location.host}`);
        fetch(url.href)
            .then(r => r.json())
            .then(sections => {
            setCache(p => (Object.assign(Object.assign({}, p), { topLevelSections: sections })));
            CacheInitialized = true;
        })
            .catch(alert);
    }
    (0, react_1.useEffect)(() => {
        function mountEventHandler(ev) {
            if (ev.type !== EVENT_MOUNT) {
                return;
            }
            const mountEvent = ev;
            setPortals(previous => [...previous, mountEvent.detail]);
        }
        runtimeTarget.addEventListener(EVENT_MOUNT, mountEventHandler);
        if (onInit) {
            onInit();
        }
        return () => {
            runtimeTarget.removeEventListener(EVENT_MOUNT, mountEventHandler);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(cache_1.Provider, { value: [cache, setCache], children: (0, jsx_runtime_1.jsx)(PortalMounter, { portals: portals }) }));
}
const PortalMounter = (0, react_1.memo)(({ portals }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: portals.map((props, index) => ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)(SectionsWidget_1.SectionsWidget, Object.assign({}, props)), props.mountTarget, index.toString()) }, index))) }));
});
function prepareRuntime(runtimeTarget) {
    if (!runtimeTarget) {
        const elem = document.createElement('meta');
        document.body.insertAdjacentElement('beforeend', elem);
        runtimeTarget = elem;
    }
    runtimeTarget.dataset.sectionsAutocompleteRuntime = '';
    return new Promise((resolve) => {
        const options = { runtimeTarget, onInit: () => { resolve(runtimeTarget); } };
        (0, react_dom_1.render)((0, jsx_runtime_1.jsx)(RuntimeComponent, { options: options }), options.runtimeTarget);
    });
}
function mountAutocomplete(target, options = { shouldHideAfterSelect: true }) {
    const event = new CustomEvent(EVENT_MOUNT, {
        detail: Object.assign({ mountTarget: target }, options),
        bubbles: true,
    });
    const runtimeElement = document.querySelector('[data-sections-autocomplete-runtime]');
    if (!runtimeElement) {
        throw new Error('SectionsAutocomplete runtime not found');
    }
    runtimeElement.dispatchEvent(event);
}
